define("checkout/components/seamless-checkout-table/charges", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{! Monthly Yearly Total }}
  
  {{#if this.shouldDisplayTaxAmount}}
    <div class="tCK--table__row">
      <div class="tCK--table__data u--flex__col u--flex__alignItems--start">
        {{#if @isVariant}}
          <div class="u--text--bold qa--checkout__summary--planText">
            {{#if @isMonthly}}
              {{t
                "plans.checkout.plan.line_item_monthly_total_on_date_trial"
                date=(moment-format @proration.futureDate "MMM DD, YYYY")
              }}
            {{else}}
              {{t
                "plans.checkout.plan.line_item_yearly_total_on_date_trial"
                date=(moment-format @proration.futureDate "MMM DD, YYYY")
              }}
            {{/if}}
          </div>
        {{else}}
          <span class="u--text--bold">
            {{t "shared_words.subtotal"}}
          </span>
        {{/if}}
      </div>
      <div class="tCK--table__data u--flex__col u--flex__alignItems--end">
        <span class="qa--checkout__summary--totalText qa--total_value">
          {{format-currency @proration.futureAmount}}
        </span>
      </div>
    </div>
    <div class="tCK--table__row">
      <div class="tCK--table__data u--flex__col u--flex__alignItems--start">
        <span>
          {{#if (or this.isMissingTaxData this.hasUnsavedAddressChanges)}}
            {{t "shared_words.tax"}}
          {{else}}
            {{t "checkout.tax.vat_rate" rate=this.taxRate}}
          {{/if}}
        </span>
      </div>
      <div class="tCK--table__data u--flex__col u--flex__alignItems--end">
        {{#if this.isLoadingTaxAmount}}
          <span class="u--text--light u--text--sm">
            {{t "checkout.tax.loading"}}
          </span>
        {{else if this.hasUnsavedAddressChanges}}
          <span class="u--text--light u--text--sm">
            {{t "checkout.tax.to_calculate"}}
          </span>
        {{else}}
          <span class="qa--checkout__summary--totalText qa--total_value">
            {{format-currency this.taxAmount}}
          </span>
          {{#if this.hasPendingTaxId}}
            <p class="u--text--light u--text--sm">
              {{t "checkout.tax.tax_id.pending_disclaimer"}}
            </p>
          {{/if}}
        {{/if}}
      </div>
    </div>
    {{#unless @isVariant}}
      <hr class="tCK--table__divider u--m__tb__sm" />
      <div class="tCK--table__row">
        <div class="tCK--table__data u--flex__col u--flex__alignItems--start u--text--bold">
          {{t "checkout.tax.future_date" date=this.futureDate interval=this.interval}}
        </div>
  
        {{#if this.isLoadingTaxAmount}}
          <span class="u--text--light u--text--sm">
            {{t "checkout.tax.loading"}}
          </span>
        {{else}}
          <div class="tCK--table__data u--flex__col u--flex__alignItems--end u--text--bold">
            {{format-currency this.totalAmount}}
          </div>
        {{/if}}
      </div>
    {{/unless}}
  
    {{#if (or @isEligibleForTrial @hasActiveTrial)}}
      <hr class="tCK--table__divider u--m__tb__sm" />
      <div class="tCK--table__row">
        <div class="tCK--table__data u--flex__col u--flex__alignItems--start">
          <span class="u--text--success u--text--bold" data-test-id="trial-amount">
            {{t "plans.checkout.plan.trial_total_today_days_free"}}
          </span>
        </div>
        <div class="tCK--table__data u--flex__col u--flex__alignItems--end">
          <span class="u--text--lg u--text--success u--text--bold">{{t "plans.checkout.plan.trial_total_amount"}}</span>
        </div>
      </div>
  
    {{else if this.hasProratedTotal}}
      <hr class="tCK--table__divider u--m__tb__sm" />
  
      <div class="tCK--table__row">
        <div class="tCK--table__data u--flex__col u--flex__alignItems--start">
          <span class="u--text--bold u--text--success u--text--md">
            {{t "plans.checkout.plan.line_item_total_prorated"}}
          </span>
        </div>
        <div class="tCK--table__data u--flex__col u--flex__alignItems--end">
          {{#unless this.isLoadingTaxAmount}}
            <span class="u--text--bold u--text--success u--text--lg">{{this.totalAmountToday}}</span>
            {{#if @proration.proratedTaxAmount}}
              <span class="u--text--light u--text--sm">
                {{t "checkout.tax.prorated_tax" amount=(format-currency @proration.proratedTaxAmount)}}
              </span>
            {{/if}}
          {{/unless}}
        </div>
      </div>
    {{/if}}
  {{else}}
    <div class="tCK--table__row">
      <div class="tCK--table__data u--flex__col u--flex__alignItems--start">
        <div class="u--text--bold qa--checkout__summary--planText">
          {{#if @isMonthly}}
            {{t
              "plans.checkout.plan.line_item_monthly_total_on_date_trial"
              date=(moment-format @proration.futureDate "MMM DD, YYYY")
            }}
          {{else}}
            {{t
              "plans.checkout.plan.line_item_yearly_total_on_date_trial"
              date=(moment-format @proration.futureDate "MMM DD, YYYY")
            }}
          {{/if}}
        </div>
      </div>
      <div class="tCK--table__data u--flex__col u--flex__alignItems--end">
        <span class="u--text--bold qa--checkout__summary--totalText qa--total_value">
          {{format-currency @proration.futureAmount}}
        </span>
        <span class="u--text--light u--text--sm">
          {{t "plans.checkout.plan.plus_tax"}}
        </span>
      </div>
    </div>
  
    {{#if (or @isEligibleForTrial @hasActiveTrial)}}
      <hr class="tCK--table__divider u--m__tb__sm" />
      <div class="tCK--table__row">
        <div class="tCK--table__data u--flex__col u--flex__alignItems--start">
          <span class="u--text--success u--text--bold" data-test-id="trial-amount">
            {{t "plans.checkout.plan.trial_total_today_days_free"}}
          </span>
        </div>
        <div class="tCK--table__data u--flex__col u--flex__alignItems--end">
          <span class="u--text--lg u--text--success u--text--bold">{{t "plans.checkout.plan.trial_total_amount"}}</span>
        </div>
      </div>
  
    {{else if this.hasProratedTotal}}
      <hr class="tCK--table__divider u--m__tb__sm" />
      <div class="tCK--table__row">
        <div class="tCK--table__data u--flex__col u--flex__alignItems--start">
          <span class="u--text--bold u--text--success u--text--md">
            {{t "plans.checkout.plan.line_item_total_prorated"}}
          </span>
        </div>
        <div class="tCK--table__data u--flex__col u--flex__alignItems--end">
          <span class="u--text--bold u--text--success u--text--lg">{{format-currency @proration.immediateAmount}}</span>
          <span class="u--text--light u--text--sm">
            {{t "plans.checkout.plan.plus_tax"}}
          </span>
        </div>
      </div>
    {{/if}}
  {{/if}}
  <ChargesSummary
    @amountWhenDiscountExpiresAfterTax={{this.amountWhenDiscountExpiresAfterTax}}
    @currentSubscriptionPlan={{@currentSubscriptionPlan}}
    @hasActiveTrial={{@hasActiveTrial}}
    @hasCheckoutChanges={{@hasCheckoutChanges}}
    @hasExpiringDiscount={{@hasExpiringDiscount}}
    @isEligibleForTrial={{@isEligibleForTrial}}
    @proration={{@proration}}
    @remainingDiscountDuration={{@remainingDiscountDuration}}
    @selectedSubscriptionPlan={{@selectedSubscriptionPlan}}
  />
  */
  {
    "id": "ZTnID0Eh",
    "block": "[[[1,\"\\n\"],[41,[30,0,[\"shouldDisplayTaxAmount\"]],[[[1,\"  \"],[10,0],[14,0,\"tCK--table__row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--start\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"        \"],[10,0],[14,0,\"u--text--bold qa--checkout__summary--planText\"],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"            \"],[1,[28,[35,1],[\"plans.checkout.plan.line_item_monthly_total_on_date_trial\"],[[\"date\"],[[28,[37,2],[[30,3,[\"futureDate\"]],\"MMM DD, YYYY\"],null]]]]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,1],[\"plans.checkout.plan.line_item_yearly_total_on_date_trial\"],[[\"date\"],[[28,[37,2],[[30,3,[\"futureDate\"]],\"MMM DD, YYYY\"],null]]]]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_words.subtotal\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--end\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"qa--checkout__summary--totalText qa--total_value\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[[30,3,[\"futureAmount\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"tCK--table__row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--start\"],[12],[1,\"\\n      \"],[10,1],[12],[1,\"\\n\"],[41,[28,[37,4],[[30,0,[\"isMissingTaxData\"]],[30,0,[\"hasUnsavedAddressChanges\"]]],null],[[[1,\"          \"],[1,[28,[35,1],[\"shared_words.tax\"],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,1],[\"checkout.tax.vat_rate\"],[[\"rate\"],[[30,0,[\"taxRate\"]]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--end\"],[12],[1,\"\\n\"],[41,[30,0,[\"isLoadingTaxAmount\"]],[[[1,\"        \"],[10,1],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"checkout.tax.loading\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"hasUnsavedAddressChanges\"]],[[[1,\"        \"],[10,1],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"checkout.tax.to_calculate\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,1],[14,0,\"qa--checkout__summary--totalText qa--total_value\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[[30,0,[\"taxAmount\"]]],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasPendingTaxId\"]],[[[1,\"          \"],[10,2],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"checkout.tax.tax_id.pending_disclaimer\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"]],[]]]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[51,[30,1]],[[[1,\"    \"],[10,\"hr\"],[14,0,\"tCK--table__divider u--m__tb__sm\"],[12],[13],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__row\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--start u--text--bold\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"checkout.tax.future_date\"],[[\"date\",\"interval\"],[[30,0,[\"futureDate\"]],[30,0,[\"interval\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isLoadingTaxAmount\"]],[[[1,\"        \"],[10,1],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"checkout.tax.loading\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--end u--text--bold\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[[30,0,[\"totalAmount\"]]],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,4],[[30,4],[30,5]],null],[[[1,\"    \"],[10,\"hr\"],[14,0,\"tCK--table__divider u--m__tb__sm\"],[12],[13],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__row\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--start\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--success u--text--bold\"],[14,\"data-test-id\",\"trial-amount\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"plans.checkout.plan.trial_total_today_days_free\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--end\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--lg u--text--success u--text--bold\"],[12],[1,[28,[35,1],[\"plans.checkout.plan.trial_total_amount\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"]],[]],[[[41,[30,0,[\"hasProratedTotal\"]],[[[1,\"    \"],[10,\"hr\"],[14,0,\"tCK--table__divider u--m__tb__sm\"],[12],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"tCK--table__row\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--start\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--bold u--text--success u--text--md\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"plans.checkout.plan.line_item_total_prorated\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--end\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"isLoadingTaxAmount\"]]],[[[1,\"          \"],[10,1],[14,0,\"u--text--bold u--text--success u--text--lg\"],[12],[1,[30,0,[\"totalAmountToday\"]]],[13],[1,\"\\n\"],[41,[30,3,[\"proratedTaxAmount\"]],[[[1,\"            \"],[10,1],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"checkout.tax.prorated_tax\"],[[\"amount\"],[[28,[37,3],[[30,3,[\"proratedTaxAmount\"]]],null]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],null]],[]]]],[]],[[[1,\"  \"],[10,0],[14,0,\"tCK--table__row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--start\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--text--bold qa--checkout__summary--planText\"],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"          \"],[1,[28,[35,1],[\"plans.checkout.plan.line_item_monthly_total_on_date_trial\"],[[\"date\"],[[28,[37,2],[[30,3,[\"futureDate\"]],\"MMM DD, YYYY\"],null]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,1],[\"plans.checkout.plan.line_item_yearly_total_on_date_trial\"],[[\"date\"],[[28,[37,2],[[30,3,[\"futureDate\"]],\"MMM DD, YYYY\"],null]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--end\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--bold qa--checkout__summary--totalText qa--total_value\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[[30,3,[\"futureAmount\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"plans.checkout.plan.plus_tax\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[28,[37,4],[[30,4],[30,5]],null],[[[1,\"    \"],[10,\"hr\"],[14,0,\"tCK--table__divider u--m__tb__sm\"],[12],[13],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__row\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--start\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--success u--text--bold\"],[14,\"data-test-id\",\"trial-amount\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"plans.checkout.plan.trial_total_today_days_free\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--end\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--lg u--text--success u--text--bold\"],[12],[1,[28,[35,1],[\"plans.checkout.plan.trial_total_amount\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"]],[]],[[[41,[30,0,[\"hasProratedTotal\"]],[[[1,\"    \"],[10,\"hr\"],[14,0,\"tCK--table__divider u--m__tb__sm\"],[12],[13],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__row\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--start\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--bold u--text--success u--text--md\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"plans.checkout.plan.line_item_total_prorated\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__col u--flex__alignItems--end\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--bold u--text--success u--text--lg\"],[12],[1,[28,[35,3],[[30,3,[\"immediateAmount\"]]],null]],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"plans.checkout.plan.plus_tax\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],null]],[]]]],[]]],[8,[39,6],null,[[\"@amountWhenDiscountExpiresAfterTax\",\"@currentSubscriptionPlan\",\"@hasActiveTrial\",\"@hasCheckoutChanges\",\"@hasExpiringDiscount\",\"@isEligibleForTrial\",\"@proration\",\"@remainingDiscountDuration\",\"@selectedSubscriptionPlan\"],[[30,0,[\"amountWhenDiscountExpiresAfterTax\"]],[30,6],[30,5],[30,7],[30,8],[30,4],[30,3],[30,9],[30,10]]],null]],[\"@isVariant\",\"@isMonthly\",\"@proration\",\"@isEligibleForTrial\",\"@hasActiveTrial\",\"@currentSubscriptionPlan\",\"@hasCheckoutChanges\",\"@hasExpiringDiscount\",\"@remainingDiscountDuration\",\"@selectedSubscriptionPlan\"],false,[\"if\",\"t\",\"moment-format\",\"format-currency\",\"or\",\"unless\",\"charges-summary\"]]",
    "moduleName": "checkout/components/seamless-checkout-table/charges.hbs",
    "isStrictMode": false
  });
  let ChargesSummaryComponent = _exports.default = (_class = class ChargesSummaryComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "locale", _descriptor3, this);
    }
    get amountWhenDiscountExpires() {
      return this.args.proration.futureAmount + this.args.discountAmount;
    }
    get amountWhenDiscountExpiresAfterTax() {
      if (this.address.shouldDisplayTaxAmount) {
        return this.locale.formatCurrency((((this.amountWhenDiscountExpires ?? 0) + this.taxAmount) / 100).toFixed(2));
      }
      const amount = this.locale.formatCurrency(((this.amountWhenDiscountExpires ?? 0) / 100).toFixed(2));
      return this.intl.t('plans.checkout.plan.amount_plus_tax', {
        amount
      });
    }
    get futureDate() {
      return this.args.proration.futureDate.format('MMM D, YYYY');
    }
    get hasProratedTotal() {
      return this.args.proration.immediateAmount > 0;
    }
    get hasUnsavedAddressChanges() {
      return this.address.hasUnsavedChanges;
    }
    get hasPendingTaxId() {
      return Boolean(
      // Note: validation is done asynchronously after checkout so we treat any newly entered ID as pending
      this.args.hasEnteredValidTaxId || this.args.taxIdData?.status === 'pending' || this.args.taxIdData?.status === 'unavailable');
    }
    get shouldDisplayTaxAmount() {
      return this.address.shouldDisplayTaxAmount;
    }
    get interval() {
      if (this.args.isMonthly) {
        return this.intl.t('shared_words.monthly');
      }
      return this.intl.t('shared_words.yearly');
    }
    get isLoadingTaxAmount() {
      // Note: We load the proration on any checkout changes but tax amount is only shown with a saved address
      return this.args.proration.isLoading && this.address.isSavedAddressValid;
    }
    get isMissingTaxData() {
      return this.args.proration.isMissingTaxData;
    }
    get taxRate() {
      return this.args.proration.taxRate;
    }
    get taxAmount() {
      return this.args.proration.taxAmount;
    }
    get totalAmount() {
      return this.args.proration.futureAmount + this.taxAmount;
    }
    get totalAmountToday() {
      return this.args.proration.immediateAmountAfterTax;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ChargesSummaryComponent);
});